import { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Form, Field } from 'redux-form';

import { TextArea, SelectField } from 'common/components/forms';
// eslint-disable-next-line import/no-cycle
import { Modal, FormError } from 'common/components/layout';
import { cancelClubMembership } from 'redux/clubMemberships/actions';

import { validateCancel } from './validators';

class CancelClubMembership extends Component {
  handleSubmit = (form) => {
    const { props } = this;
    const data = transformData(form, props);
    const successFunction = () => {
      props.onCloseModal();
    };
    props.cancelClubMembership(props.clubMembershipId, data, successFunction);
  };

  handleClose = (e) => {
    const { props } = this;
    e.preventDefault();
    props.onCloseModal();
  };

  render() {
    const { handleSubmit, form, onCloseModal } = this.props;

    return (
      <Modal
        className="c7-modal__content--add-hold"
        title="Cancel Your Club Membership"
        onCloseModal={onCloseModal}
        formName={form}
      >
        <FormError formName={form} />
        <Form
          onSubmit={handleSubmit(this.handleSubmit)}
          className="c7-form"
          method="post"
        >
          <Field
            name="cancellationReason"
            component={SelectField}
            label="Reason"
            optionArray={cancellationReasons()}
            required
          />
          <Field
            name="cancellationComments"
            component={TextArea}
            label="Comments"
            rows={6}
          />
          <div className="c7-form__button-row">
            <a onClick={this.handleClose} className="c7-button-alt">
              Cancel
            </a>
            <button type="submit" className="c7-button">
              Cancel Membership
            </button>
          </div>
        </Form>
      </Modal>
    );
  }
}

const transformData = (values) => {
  const data = {
    cancellationReason: values.cancellationReason,
    cancellationComments: values.cancellationComments
  };
  return data;
};

const validate = (values, ownProps) => {
  const data = transformData(values, ownProps);
  const errors = validateCancel(data);
  return errors;
};

const mapStateToProps = () => ({
  initialValues: {}
});

const cancellationReasons = () => [
  { value: '', option: '' },
  { value: 'Too much wine', option: 'Too much wine' },
  { value: 'Financial reasons', option: 'Financial reasons' },
  { value: 'Health reasons', option: 'Health reasons' },
  { value: 'Pregnant', option: 'Pregnant' },
  { value: 'Moving', option: 'Moving' },
  { value: 'Other', option: 'Other' }
];

CancelClubMembership = reduxForm({
  form: 'CancelClubMembership',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(CancelClubMembership);

export default connect(mapStateToProps, {
  cancelClubMembership
})(CancelClubMembership);
